import { PageHero } from "@/pages/About";

export default function TermsOfUse() {
    return (
        <div>
            <PageHero title="Terms of Use" subtitle="Website terms of use" />
            <section className="gsf-section" data-testid="terms-content">
                <div className="gsf-container max-w-3xl space-y-6 text-[color:var(--gsf-body)] leading-relaxed">
                    <p>
                        By using www.globalseedzim.org you agree to these terms of use. This website is provided for
                        information, community engagement and donor engagement in support of Global Seed Foundation's
                        community development work.
                    </p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold mt-6">Content</h3>
                    <p>The Foundation makes reasonable efforts to keep content accurate. Programme information may change as community priorities evolve. Impact figures are updated as verified data is consolidated and displayed only when marked <em>verified</em>.</p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">Donations</h3>
                    <p>Donations are received through the disclosed bank transfer arrangements. The temporary donation arrangement is fully disclosed on the Donate page. Donors may request acknowledgement and supporting documentation by writing to impact@globalseedzim.org.</p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">Intellectual property</h3>
                    <p>The Global Seed Foundation name, logo and content are the property of the Foundation. Please contact us before reproducing content.</p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">Contact</h3>
                    <p><a className="underline text-[color:var(--gsf-green-700)]" href="mailto:impact@globalseedzim.org">impact@globalseedzim.org</a></p>
                </div>
            </section>
        </div>
    );
}
